import { Injectable, signal, WritableSignal } from '@angular/core';
import { GameSettingViewModel } from '@app/shared/rest-api';

@Injectable({
  providedIn: 'root'
})
export class GameSettingsService {
  public readonly gameSettings: WritableSignal<GameSettingViewModel> = signal({} as GameSettingViewModel);

  constructor() { }

  getGameSettings(): GameSettingViewModel {
    return this.gameSettings();
  }

  setGameSettings(gameSettings: GameSettingViewModel): void {
    this.gameSettings.set(gameSettings);
  }

}
